import React from "react";

// @ts-ignore
import style from './defaultPadding.module.css';
const DefaultPadding = ({row}) => {
    return <div className={style.item}>{row?.label || ''}</div>;

}

export default DefaultPadding;